// import React, { useEffect } from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
// import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import Banner from "../assets/BannerImage2.png"
const Sliderimages = () => {

  // useEffect(() => {
  //   const timeout = setTimeout(() => {
  //     setA(true); // example delay state
  //   }, 2000);
  //   if (AllImages?.length > 0) {
  //     const img = new Image();
  //     img.src = AllImages[0].src;
  //     img.onload = () => {
  //       onImagesLoaded?.(true); // Notify once loaded
  //       setNoimages(false);
  //     };
  //   } else {
  //     setBannerReady(false); // Even if empty
  //     setNoimages(true)

  //   }
  //   return () => clearTimeout(timeout); // Clean up
  // }, [AllImages, onImagesLoaded, setA, setBannerReady, setNoimages]);

  // const CustomPrevArrow = ({ onClick }) => (
  //   <>{AllImages.length > 1 && <button
  //     onClick={onClick}
  //     className="absolute left-2 top-1/2 z-10 -translate-y-1/2 rounded-full bg-white p-2 text-primary opacity-0 transition-all group-hover:opacity-100"
  //   >
  //     <IoIosArrowBack size={28} />
  //   </button>}</>
  // );

  // const CustomNextArrow = ({ onClick }) => (
  //   <>
  //     {AllImages.length > 1 && <button
  //       onClick={onClick}
  //       className="absolute right-2 top-1/2 z-10 -translate-y-1/2 rounded-full bg-white p-2 text-primary opacity-0 transition-all group-hover:opacity-100"
  //     >
  //       <IoIosArrowForward size={28} />
  //     </button>}
  //   </>
  // );

  const sliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    infinite: false,
  };

  // ✅ Render slider if images exist
  // if (AllImages?.length > 0) {
  return (
    <motion.section
      className="relative"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeInOut" }}
    >
      <Slider {...sliderSettings} className="group">
        {/* {AllImages.map((image, index) => ( */}
        <motion.div transition={{ duration: 0.4 }}>
          <div className="relative">
            <img
              src={Banner}
              alt={"Banner"}
              className="w-full h-auto object-cover"
              loading="lazy"
            />
          </div>
        </motion.div>
        {/* ))} */}
      </Slider>
    </motion.section>
  );
  // }
  // console.log(a)
  // // ❌ No images → fallback hero banner
  // if (AllImages.length === 0 && noimages) {
  //   return (
  //     <>
  //       {a && <motion.section
  //         className="relative overflow-hidden min-h-screen"
  //         initial={{ opacity: 0, y: 50 }}
  //         animate={{ opacity: 1, y: 0 }}
  //         transition={{ duration: 0.8, ease: "easeInOut" }}
  //       >
  //         {/* Background */}
  //         <div
  //           className="absolute inset-0 bg-cover bg-center"
  //           style={{
  //             backgroundImage:
  //               "url('https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?auto=format&fit=crop&q=80')",
  //           }}
  //         />
  //         <div className="absolute inset-0 bg-black opacity-40" />
  //         <div className="relative z-10 max-w-7xl mx-auto px-4 py-20 sm:py-24 lg:py-16">
  //           <div className="grid lg:grid-cols-2 gap-12 items-center">
  //             {/* Text */}
  //             <motion.div
  //               initial={{ opacity: 0, y: 50 }}
  //               animate={{ opacity: 1, y: 0 }}
  //               transition={{ duration: 1 }}
  //               className="text-center lg:text-left"
  //             >
  //               <h1 className="text-2xl md:text-5xl font-bold text-white mb-6">
  //                 LOKMANYA
  //                 <span className="block text-2xl md:text-4xl text-[#FFB800]">
  //                   GROUP OF COLLEGES
  //                 </span>
  //               </h1>
  //               <p className="text-md md:text-2xl text-white font-light flex">
  //                 SHAPING FUTURES
  //                 <span className="block ml-1">WITH EXCELLENCE</span>
  //               </p>
  //             </motion.div>

  //             {/* Circle Images */}
  //             <motion.div
  //               initial={{ opacity: 0 }}
  //               animate={{ opacity: 1 }}
  //               transition={{ duration: 1.2 }}
  //               className="relative grid grid-cols-2 gap-4"
  //             >
  //               <div className="aspect-square rounded-full overflow-hidden border-4 border-white/20">
  //                 <img
  //                   src="https://images.unsplash.com/photo-1525921429624-479b6a26d84d?q=80&w=2070&auto=format&fit=crop"
  //                   alt="College Life"
  //                   className="w-full h-full object-cover"
  //                 />
  //               </div>
  //               <div className="aspect-square rounded-full overflow-hidden border-4 border-white/20 mt-12">
  //                 <img
  //                   src="https://images.unsplash.com/photo-1571260899304-425eee4c7efc?q=80&w=2070&auto=format&fit=crop"
  //                   alt="Student Activities"
  //                   className="w-full h-full object-cover"
  //                 />
  //               </div>
  //               <div className="aspect-square rounded-full overflow-hidden border-4 border-white/20 -mt-12">
  //                 <img
  //                   src="https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?q=80&w=2070&auto=format&fit=crop"
  //                   alt="Campus Life"
  //                   className="w-full h-full object-cover"
  //                 />
  //               </div>
  //             </motion.div>
  //           </div>
  //         </div>
  //       </motion.section>}
  //     </>
  //   );

  // }
};

export default Sliderimages;
